import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../settings/config.json';
import { Button, Modal, Form, Input } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

function AllVideo() {
  const [videos, setVideos] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`/api/video`);
        setVideos(response.data);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchVideos();

    const interval = setInterval(fetchVideos, 3000);
    return () => clearInterval(interval);
  }, []);

  const showEditModal = (video) => {
    setCurrentVideo(video);
    form.setFieldsValue({ title: video.title });
    setIsModalVisible(true);
  };

  const handleEditOk = async () => {
    try {
      const values = await form.validateFields();
      const response = await axios.put(
        `/api/video/${currentVideo._id}`,
        { title: values.title },
      );

      setVideos(videos.map(video =>
        video._id === currentVideo._id ? { ...video, title: values.title } : video
      ));
      setIsModalVisible(false);
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  const handleEditCancel = () => {
    setIsModalVisible(false);
    setCurrentVideo(null);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/video/${id}`);
      setVideos(videos.filter(video => video._id !== id));
    } catch (error) {
      console.error('ERROR:', error);
    }
  };

  return (
    <div className='Poems'>
      {videos.length > 0 ? (
        <ul className='message-list'>
          {videos.map(video => (
            <li key={video._id} className='message-item'>
              {video.video && (
                <video 
                  src={`/api${video.video}`}
                  width="200px"
                  className="p-1 me-3"
                  controls
                />
              )}
              <div className='message-details'>
                <p className='name text-white'>{video.title}</p>
                <p className='date'>{new Date(video.date).toLocaleString()}</p>
              </div>
              <Button 
                className='like-button me-2 text-warning'
                icon={<EditOutlined />}
                onClick={() => showEditModal(video)}
              />
              <Button 
                className='like-button me-2 text-danger'
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(video._id)}
              />
              <hr />
            </li>
          ))}
        </ul>
      ) : (
        <center className='mt-5'>
          <h2 className='text-gradient'>Oops...</h2>
          <h4 className='mt-3 text-secondary font-reqular'>Video yoxdur</h4>
          <br /><br /><br />
        </center>
      )}
      <Modal
        title="Video redaktə edin"
        visible={isModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
        >
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: 'Введите имя' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default AllVideo;